import Personnummer from 'personnummer';

export const ageResolver = (cpr: string) => Personnummer.parse(cpr).getAge();

export function removeKommunPostfix(municipalityInput: string) {
  if (municipalityInput.length > 12) {
    if (municipalityInput.slice(-6).toLowerCase() === 'kommun') {
      return municipalityInput.slice(0, -6).trim();
    }
    if (municipalityInput.slice(-5).toLowerCase() === 'komun') {
      return municipalityInput.slice(0, -5).trim();
    }
    return municipalityInput.trim();
  }
  return municipalityInput.trim();
}

export const collapseWhitespace = (inputString: string) => {
  return inputString.replace(/\s+/g, ' ');
};

export const collapsePropertyIdWhitespace = (inputString: string) => {
  return inputString.replace(/\s*:\s*/g, ':');
};
